import React from "react";
import { ChevronDown } from "lucide-react";

// Bloco recolhível com resumo do que está configurado dentro.
//
// O resumo é o ponto: sem ele, saber se o horário de atendimento está ligado
// exige abrir a seção. Com ele, a pessoa lê a tela inteira de uma vez e só
// abre o que vai mexer.
const Secao = ({ titulo, resumo, icone: Icone, aberta, onToggle, children }) => (
	<div className="rounded-lg border">
		<button
			type="button"
			onClick={onToggle}
			aria-expanded={aberta}
			className="flex w-full items-center gap-3 p-3 text-left transition-colors hover:bg-muted/50"
		>
			{Icone && (
				<Icone className="h-4 w-4 shrink-0 text-muted-foreground" />
			)}
			<span className="min-w-0 flex-1">
				<span className="block text-sm font-medium">{titulo}</span>
				<span className="mt-0.5 block truncate text-xs text-muted-foreground">
					{resumo}
				</span>
			</span>
			<ChevronDown
				className={`h-4 w-4 shrink-0 text-muted-foreground transition-transform ${
					aberta ? "rotate-180" : ""
				}`}
			/>
		</button>

		{aberta && (
			<div className="space-y-4 border-t p-3 pt-4">{children}</div>
		)}
	</div>
);

export default Secao;
